import AXIOS from '@/utils/$axios';

export const createProject = payload => {
    let config = {}
    if (payload.isApp) {
        config = {
            headers: {
                common: {
                    token: payload.token
                }
            },
        }
    }
    return AXIOS.post('/space/project/project/temp', {}, config)
}

// 申请企业试用
export const enterpriseUserAdd = data => AXIOS.post('/hdc-admin/enterprise/user/add', data);
